import {
  GET_LIST_OF_VALUES_CLAIM_DOCUMENT,
  GET_PHONE_DATA,
  GET_PO_FULL_NAME_DATA,
  GET_POLICY_PROVINCE,
  SET_LIST_OF_VALUES_CLAIM_DOCUMENT,
  GET_BANK_EMPLOYEE_CODE,
  GET_BANK_REFFERER_CODE,
  SET_BANK_EMPLOYEE_CODE,
  SET_BANK_REFFERER_CODE,
  SET_POLICY_PROVINCE,
} from '@stores/policy/constants.js';
import { searchBankEmployeeCodeService } from '@services/policy/policy.js';

const getPhoneByPolAction = (payload, callback) => ({
  type: GET_PHONE_DATA,
  payload,
  callback,
});

const getPOFullNameByPolAction = (payload, callback) => ({
  type: GET_PO_FULL_NAME_DATA,
  payload,
  callback,
});

const getPolicySearchProvinceRequest = (payload) => ({
  type: GET_POLICY_PROVINCE,
  payload,
});

const setPolicySearchProvinceRequest = (payload) => ({
  type: SET_POLICY_PROVINCE,
  payload,
});

const getLovClaimDocumentRequest = (payload) => ({
  type: GET_LIST_OF_VALUES_CLAIM_DOCUMENT,
  payload,
});

const setLovClaimDocumentRequest = (payload) => ({
  type: SET_LIST_OF_VALUES_CLAIM_DOCUMENT,
  payload,
});

const getBankEmployeeCodeRequest = (payload, callback) => ({
  type: GET_BANK_EMPLOYEE_CODE,
  payload,
  callback,
});

const setBankEmployeeCodeRequest = (payload, callback) => ({
  type: SET_BANK_EMPLOYEE_CODE,
  payload,
  callback,
});

const getBankReffererCodeRequest = (payload, callback) => ({
  type: GET_BANK_REFFERER_CODE,
  payload,
  callback,
});

const setBankReffererCodeRequest = (payload, callback) => ({
  type: SET_BANK_REFFERER_CODE,
  payload,
  callback,
});

export {
  getPhoneByPolAction,
  getPOFullNameByPolAction,
  setPolicySearchProvinceRequest,
  getPolicySearchProvinceRequest,
  getLovClaimDocumentRequest,
  setLovClaimDocumentRequest,
  getBankEmployeeCodeRequest,
  setBankEmployeeCodeRequest,
  getBankReffererCodeRequest,
  setBankReffererCodeRequest,
};
